package app.bloomey.web.modules.video

import com.copperleaf.ballast.InputHandler
import com.copperleaf.ballast.InputHandlerScope
import kotlinx.coroutines.flow.collectLatest

class VideoInputHandler : InputHandler<VideoContract.Inputs, VideoContract.Events, VideoContract.State> {

    private val repository = VideoRepository()
    override suspend fun InputHandlerScope<VideoContract.Inputs, VideoContract.Events, VideoContract.State>.handleInput(
        input: VideoContract.Inputs,
    ): Unit = when (input) {
        is VideoContract.Inputs.GetVideos -> {
            repository.getVideos(input.page, input.size, input.query).collectLatest { state ->
                updateState {
                    var update = it
                    update = if (state.isSuccess)
                        update.copy(
                            videos = if (input.page > update.page)
                                update.videos.toMutableList().plus(state.getData.items)
                            else
                                state.getData.items,
                            nextPage = state,
                            page = input.page,
                            lastPage = state.getData.items.size < input.size
                        )
                    else
                        update.copy(nextPage = state)
                    update
                }
            }
        }

        is VideoContract.Inputs.DeleteVideo -> {
            repository.deleteVideo(input.id).collectLatest { state ->
                updateState {
                    it.copy(deleteVideo = state)
                }
            }
        }

        is VideoContract.Inputs.UpdateVideo -> {
            repository.updateVideo(input.id, input.request).collectLatest { state ->
                updateState {
                    it.copy(updateVideo = state)
                }
            }
        }
    }
}
